export default __webpack_public_path__ + "static/media/500.e0d72a85.gif";